import { reactive } from 'vue';

export const profile = reactive({
  count: 0,
});